module.exports = __webpack_public_path__ + "static/media/mirrorLogo.589767a2.png";